var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3 12c0 4.9706 4.02944 9 9 9 4.9706 0 9-4.0294 9-9 0-4.97056-4.0294-9-9-9-4.97056 0-9 4.02944-9 9z",
    fill: "#ff9528",
    stroke: "#ff9528",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.0103 12.5v-5",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.01 15.88c-.076-.002-.1508.0189-.2148.0599-.064.0409-.1142.1002-.1442.17s-.0384.147-.0241.2217c.0144.0746.0508.1432.1045.197.0537.0537.1224.0901.197.1045.0746.0143.1518.0059.2217-.0241.0698-.0299.129-.0802.17-.1442s.0618-.1388.0599-.2148c0-.0981-.039-.1922-.1084-.2616s-.1635-.1084-.2616-.1084z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m12.01 15.88c-.076-.002-.1508.0189-.2148.0599-.064.0409-.1142.1002-.1442.17s-.0384.147-.0241.2217c.0144.0746.0508.1432.1045.197.0537.0537.1224.0901.197.1045.0746.0143.1518.0059.2217-.0241.0698-.0299.129-.0802.17-.1442s.0618-.1388.0599-.2148c0-.0981-.039-.1922-.1084-.2616s-.1635-.1084-.2616-.1084",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Warning.76dca77499b61fb4bd1937ab91c62d1e.svg";